import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import Maska from 'maska'
import {useAuth} from '@/plugins/auth'
import Overlay from '@/components/Overlay.vue'
import App from '@/App.vue'
import {useMicrosoftAuthService} from "@/config/useMicrosoftAuth";

Vue.use(Maska)

Vue.component('overlay', <any>Overlay)

const guard = useAuth()
const microsoftAuth = useMicrosoftAuthService()

const initializeApp = async () => {
    try {
        await microsoftAuth.initialize()
        const isOAuthRedirect = await microsoftAuth.handleRedirect()
        if (!isOAuthRedirect) await guard.auth()
    } catch (error) {
        console.error('Authentication error:', error)

        if (router.currentRoute.name !== 'login') {
            router.push({
                name: 'login',
                query: {error: 'Die Anmeldung mit Microsoft ist fehlgeschlagen'}
            })
        }
    }
}

initializeApp().finally(() => {
    new Vue({store, router, render: h => h(App)}).$mount('#app')
})

guard.watchToken()
